export default __webpack_public_path__ + "static/media/manual18.641176c7.png";